const allowedOrigins = [
  'https://devemr.growthemr.com',
  'https://beta.growthemr.com',
  'https://growthemr.com',
];

const BASE_URL = allowedOrigins.includes(window.location.origin)
  ? window.location.origin
  : 'https://devemr.growthemr.com';

export const environment = {
  production: false,
  apiUrls: {
    default: 'https://api-dev.growthemr.com',
    public: 'https://pub-api-dev.growthemr.com',
    authApiUrl: 'https://api-dev.growthemr.com',
    notificationApiUrl: 'https://dev2-notification-api.growthemr.com',
    formsInstagramApiUrl: 'https://dev2-api.growthemr.com',
    aiServiceApiUrl: 'https://aiservice.growthemr.com',
    scorecardApiUrl: 'https://scorecard.growth99.com/api',
    centralWsUrl: 'https://ws.growthemr.com/ws',
  },
  webUrl: 'https://widget-ui.growthemr.com',
  emrUrl: 'https://devemr.growthemr.com',
  reviewDomain: 'https://reviews.growthemr.com/',
  chatbotURL: 'https://chatbot.growthemr.com',
  ssrDomain: 'https://portal.growthemr.com',
  ssrHost: 'portal.growthemr.com',
  domainUrl: 'https://dev-app.growthemr.com',
  adminAppUrl: 'https://devadmin.growthemr.com',
  ALLOW_USER_TO_OLD_UI: ['mehul.kothari@growth99.com'],
  // Business IDs where dental assessment should be hidden
  GOOGLE_SOCIAL_PROFILE_CONNECT_URL: `https://accounts.google.com/o/oauth2/v2/auth?client_id=506679851055-2r6j3vkmu10use82mbtcl7dvqhe05ltc.apps.googleusercontent.com&redirect_uri=${encodeURIComponent(BASE_URL + '/business/social-media-integration-callback')}&response_type=code&scope=email%20profile%20https://www.googleapis.com/auth/business.manage&access_type=offline&prompt=consent&include_granted_scopes=false&state=channel_Google`,
  GOOGLE_PROFILE_CONNECT: `https://accounts.google.com/o/oauth2/v2/auth?client_id=506679851055-2r6j3vkmu10use82mbtcl7dvqhe05ltc.apps.googleusercontent.com&redirect_uri=${encodeURIComponent(BASE_URL + '/review/google-callback')}&response_type=code&scope=email%20profile%20https://www.googleapis.com/auth/business.manage&access_type=offline&prompt=consent&include_granted_scopes=false`,
  INSTAGRAM_PROFILE_CONNECT: `https://www.facebook.com/v23.0/dialog/oauth?client_id=3011569635751006&redirect_uri=${encodeURIComponent(BASE_URL + '/business/social-media-integration-callback')}&scope=instagram_basic,instagram_content_publish,pages_show_list,pages_messaging,instagram_manage_messages,pages_read_engagement,business_management,pages_manage_metadata,pages_read_user_content&response_type=token&state=channel_Instagram`,
  FACEBOOK_PROFILE_CONNECT_URL: `https://www.facebook.com/v23.0/dialog/oauth?client_id=3011569635751006&redirect_uri=${encodeURIComponent(BASE_URL + '/business/social-media-integration-callback')}&scope=pages_messaging,pages_show_list,pages_read_engagement,pages_manage_metadata,pages_manage_posts,pages_read_user_content,business_management,public_profile&response_type=token&state=channel_Facebook`,
  LINKEDIN_PROFILE_CONNECT_URL: `https://www.linkedin.com/oauth/v2/authorization?client_id=77xuvvbpv6uc93&redirect_uri=${encodeURIComponent(BASE_URL + '/business/social-media-integration-callback')}&scope=openid,profile,email,w_member_social&response_type=code&state=channel_Linkedin`,
  SUPPORTED_FILE_TYPES_URL:
    'https://support.growth99.com/portal/en/kb/articles/instruction-guide-to-upload-files-in-the-file-manager',

  GOOGLE_SETUP: {
    clientId:
      '969333272286-l0j30jsg7f0hq53aehbj1ue70uc5ur4o.apps.googleusercontent.com',
    redirectUri:
      'https://devemr.growthemr.com/active-agents/ai-gia/auth/google/callback',
    scopes: 'openid email profile https://www.googleapis.com/auth/calendar',
  },
  MAIL_DOMAIN: 'dev.growth99-mail.com',
  enableGoogleCalendar: true,
  hubSpot: {
    portalId: '46303591',
    formId: '79b78cb1-8b09-4a63-9228-d0b83d5d8c06',
    region: 'na1',
  },
  mcp: {
    url: 'https://mcp.growthemr.com/mcp',
    giaUrl: 'https://mcp.growthemr.com/gia',
  },
};
